import React from 'react';
import FilterToggleBar from "../FilterToggleBar/FilterToggleBar";
import SportsFilterBar from "./components/SportsFilterBar/SportsFilterBar";
import GameSlider from "../GameSlider/GameSlider";
import PlayerPositionFilterBar from "./components/PlayerPositionFilterBar/PlayerPositionFilterBar";

import './FilterBar.Mobile.style.scss';
import MarketsFilterBar from "./components/MarketsFilterBar/MarketsFilterBar";
import PlayerNameFilter from "./components/PlayerNameFilter/PlayerNameFilter";
const FilterBarMobile = ({vm, isFilterBarOpen, setFilterBarOpen}) => {
    return <div className={`FilterBarMobile`}>
        <div className={`summary-filter`}>
            <FilterToggleBar isFilterBarOpen={isFilterBarOpen}
                             setFilterBarOpen={setFilterBarOpen}
                             hideShowAll
                             vm={vm}/>
        </div>
        <div className={`advanced-filter ${isFilterBarOpen ? "open" : "close"}`}>
            <GameSlider vm={vm}/>
            <PlayerPositionFilterBar vm={vm}/>
            <MarketsFilterBar vm={vm}/>
        </div>
    </div>
}

export default FilterBarMobile;